export function hasAccess(userRoles: string[] | undefined, required: string[]): boolean {
  if (!required || required.length === 0) return true;
  if (required.includes('*')) return true;
  if (!userRoles || userRoles.length === 0) return false;
  return required.some(r => userRoles.includes(r));
}
